<div class="personal-files-table flex fl-col width-100per" style="overflow-x: hidden">
  @if( showTagFilter && is_table_active){
  <div class="flex fl-al-center flex-wrap my-4 gap-1" style="width: 100%; max-width: 100%; overflow: hidden">
    <p class="title mb-0 text-sm leading-4 text-[#000] flex-shrink-0" style="min-width: 50px">Filters</p>
    @if(showLeftScrollBtn){
    <button class="app__arrowBtn flex-shrink-0 mr-2" (click)="scrollFilters('left')" style="width: 40px; min-width: 40px">
      <span class="material-icons material-symbols-outlined"> chevron_left </span>
    </button>
    }
    <div
      #filtersContainer
      class="flex overflow-x-auto scrollbar-hide"
      (scroll)="onFiltersScroll()"
      style="scroll-behavior: smooth; min-width: 0; width: calc(100vw - 700px) !important"
    >
      @if(document_type){
      <app-shared-dropdown
        [title]="'Tags'"
        [itemType]="selectedTagList"
        [list]="tagList"
        [itemsLength]="selectedTagList.length"
        [isCustomKey]="true"
        (handleSelectChangeEmitter)="handleSelectChangeEmitter($event, 'selectedTagList')"
        [lableKey]="'key'"
        [valueKey]="'key'"
        class="ml-2 w-[85px]"
      >
      </app-shared-dropdown>
      }

      <app-shared-dropdown
        [title]="'Type'"
        [itemType]="selectedTypeList"
        [list]="typeList"
        [itemsLength]="selectedTypeList.length"
        [isCustomKey]="true"
        (handleSelectChangeEmitter)="handleSelectChangeEmitter($event, 'selectedTypeList')"
        [lableKey]="'key'"
        [valueKey]="'key'"
        class="ml-2 w-[85px]"
      >
      </app-shared-dropdown>
      @if(document_type){
      <app-shared-dropdown
        [title]="'Sent from'"
        [itemType]="selectedSentFromList"
        [list]="sentFromList"
        [itemsLength]="selectedSentFromList.length"
        [isCustomKey]="true"
        (handleSelectChangeEmitter)="handleSelectChangeEmitter($event, 'selectedSentFromList')"
        [lableKey]="'key'"
        [valueKey]="'key'"
        class="ml-2 w-[120px]"
      >
      </app-shared-dropdown>
      }
      <app-shared-dropdown
        [title]="'Vault'"
        [itemType]="selectedVaultList"
        [list]="vaultList"
        [itemsLength]="selectedVaultList.length"
        [isCustomKey]="true"
        (handleSelectChangeEmitter)="handleSelectChangeEmitter($event, 'selectedVaultList')"
        [lableKey]="'key'"
        [valueKey]="'value'"
        class="ml-2 w-[90px]"
      >
      </app-shared-dropdown>

      <!-- @if(!document_type){ -->
      <app-shared-dropdown
        [title]="'Status'"
        [itemType]="selectedStatusList"
        [list]="statusDropdownOptions"
        [itemsLength]="selectedStatusList.length"
        [isCustomKey]="true"
        (handleSelectChangeEmitter)="handleSelectChangeEmitter($event, 'selectedStatusList')"
        [lableKey]="'key'"
        [valueKey]="'value'"
        class="ml-2 w-[148px]"
      >
      </app-shared-dropdown>
      <!-- } -->

      <app-shared-dropdown
        [title]="'Date Added'"
        [itemType]="selectedLastUpdatedList"
        [list]="lastUpdatedList"
        [itemsLength]="selectedLastUpdatedList.length"
        [isCustomKey]="true"
        (handleSelectChangeEmitter)="handleSelectChangeEmitter($event, 'selectedLastUpdatedList')"
        [lableKey]="'key'"
        [valueKey]="'key'"
        class="ml-2 w-[140px]"
      >
      </app-shared-dropdown>
      <app-shared-dropdown
        [title]="'Last Updated'"
        [itemType]="selectedDateAddedList"
        [list]="dateAddedList"
        [isCustomKey]="true"
        [isMultiSelect]="false"
        (handleSelectChangeEmitter)="handleSelectChangeEmitter($event, 'selectedDateAddedList')"
        [lableKey]="'key'"
        [valueKey]="'key'"
        class="ml-2 w-[145px]"
      >
      </app-shared-dropdown>
      <div class="w-[180px]" *ngIf="!isSharedWithMe && !isSharedWithOther">
        <button
          (click)="toggleDuplicateFilter()"
          [disabled]="(fileListItems | duplicateCount : 'form_name') === 0"
          [ngClass]="{
            'bg-[#FFF0C3] border-[#DEA000] text-[#DEA000]': showOnlyDuplicates,
            'bg-transparent text-[#DEA000] hover:bg-[#fff0c3] border-[#D3DCE8] hover:text-[#DEA000]':
              !showOnlyDuplicates && (fileListItems | duplicateCount : 'form_name') > 0,
            'bg-[#FFFFFF] text-[#B7B8BB] border-[#B7B8BB] cursor-default': (fileListItems | duplicateCount : 'form_name') === 0
          }"
          class="2xl:px-[13px] px-[8px] w-[180px] h-[48px] border-[1px] text-[16px] ml-2 font-semibold border-solid rounded-lg"
        >
          <div class="flex items-center justify-between">
            <div class="flex items-center justify-center">
              <div class="flex items-center justify-center h-[28px]">
                @if((fileListItems | duplicateCount:'form_name') > 0){
                <img src="assets/images/humbleicons_duplicate_color-icon.svg" class="w-[18px] h-[21px] mr-[10px]" />
                }@else{
                <img src="assets/images/humbleicons_duplicate.svg" class="w-[18px] h-[21px] mr-[10px]" />
                }
              </div>
              <div class="flex items-center" [ngClass]="{ 'text-[#DEA000]': showOnlyDuplicates }">Duplicates</div>
            </div>
            <div [ngClass]="{ 'text-[#DEA000]': showOnlyDuplicates }">
              {{ fileListItems | duplicateCount : 'form_name' || 0 }}
            </div>
          </div>
        </button>
      </div>
    </div>
    @if(showRightScrollBtn){
    <button class="app__arrowBtn flex-shrink-0 ml-2" (click)="scrollFilters('right')" style="width: 40px; min-width: 40px">
      <span class="material-icons material-symbols-outlined"> chevron_right </span>
    </button>
    }
  </div>

  } @if(is_table_active){
  <div
    class="personal-files-table__header flex width-100per flex-wrap"
    *ngIf="fileListItems.length != 0 && (filteredItems | filterWorkspace : searchText : false : (document_type ? selectedTagList : []))?.length"
  >
    <div class="w-2/5 flex fl-justify-start fl-al-center flex-1">
      <div class="w-10">
        <div style="margin-top: -8px" id="checkbox-input-select">
          @if(!isSharedWithMe){
          <mat-checkbox
            type="checkbox"
            class="checkbox-input custom-individual-checkBox"
            [(ngModel)]="allChecked"
            (change)="toggleChecklistAll($event)"
          >
          </mat-checkbox>

          }
        </div>
      </div>

      <div class="w-9 ml-4"></div>

      <div class="ml-4" style="width: calc(100% - 78px) !important">
        <p style="margin-bottom: 0px; line-height: 32px" class="cursor-pointer flex fl-al-center" (click)="sortByName()">
          Name
          <span class="material-icons f20" [style.color]="initialSort === 'name' ? '#25508e' : 'unset'">
            {{ sortedArrayByName ? 'keyboard_arrow_up ' : 'keyboard_arrow_down' }}
          </span>
        </p>
      </div>
    </div>

    <div class="flex fl-justify-end fl-al-center w-3/5 gap-1">
      <!-- <div class="w-9"></div> -->
      <!-- Tags Column Header (only show when document_type is true) -->
      @if(document_type){
      <div class="w-[80px] flex cursor-pointer" (click)="sortByTags()" style="justify-content: center">
        <p style="text-align: center; margin: 0; line-height: 32px">Tags</p>
        <span class="material-icons f20" style="margin-top: 6px" [style.color]="initialSort === 'tags' ? '#25508e' : 'unset'">
          {{ sortedArrayByTags ? 'keyboard_arrow_up ' : 'keyboard_arrow_down' }}
        </span>
      </div>
      }
      <!-- Links Column Header -->
      <div class="w-[80px] flex cursor-pointer" (click)="sortByLinks()" style="justify-content: center">
        <p style="text-align: center; margin: 0; line-height: 32px">Links</p>
        <span class="material-icons f20" style="margin-top: 6px" [style.color]="initialSort === 'links' ? '#25508e' : 'unset'">
          {{ sortedArrayByLinks ? 'keyboard_arrow_up ' : 'keyboard_arrow_down' }}
        </span>
      </div>

      
      <div class="w-[150px]" [ngClass]="{ 'w-[150px]': isGlobalSearch, 'w-[200px]': !isGlobalSearch }">
        <p class="flex fl-al-center fl-justify-center m-0" style="line-height: 32px">Vault</p>
       
      </div>
      
      <div class="w-[120px] min-w-[110px] flex cursor-pointer" (click)="sortByCreatedDate()">
        <p style="text-align: center; margin: 0; line-height: 32px">Last Updated</p>
        <span class="material-icons f20" style="margin-top: 6px" [style.color]="initialSort === 'type' ? '#25508e' : 'unset'">
          {{ sortedArrayByType ? 'keyboard_arrow_up ' : 'keyboard_arrow_down' }}
        </span>
      </div>

      @if(!isSharedFiles){
      <div class="w-[154px] min-w-[154px] flex cursor-pointer" (click)="sortByStatus()" style="justify-content: center">
        <p style="text-align: center; margin: 0; line-height: 32px">Status</p>
        <span class="material-icons f20" style="margin-top: 6px" [style.color]="initialSort === 'status' ? '#25508e' : 'unset'">
          {{ sortedArrayByStatus ? 'keyboard_arrow_up ' : 'keyboard_arrow_down' }}
        </span>
      </div>
      }@else{
      <div class="w-[154px] flex cursor-pointer" (click)="sortByAccessible()" style="justify-content: center">
        <p style="text-align: center; margin: 0; line-height: 32px">Accessible</p>
        <span class="material-icons f2 0" style="margin-top: 6px" [style.color]="initialSort === 'accessible' ? '#25508e' : 'unset'">
          {{ sortedArrayByAccessible ? 'keyboard_arrow_up ' : 'keyboard_arrow_down' }}
        </span>
      </div>

      }

      <div class="w-[62px] flex items-center justify-center"></div>
      <div class="w-[52px]"></div>
    </div>
  </div>
  }
  <div class="width-100per">
    <div
      *ngIf="(filteredItems | filterWorkspace : searchText : false : (document_type ? selectedTagList : []))?.length"
      id="{{ id }}"
      class="asset-list-item-dropbox"
    >
      @if(is_table_active){

      <cdk-virtual-scroll-viewport
        itemSize="25"
        class="virtual-scroll-container update-scroll-css"
        [style.height.px]="screenDataTableHeight"
        style="width: 100%; overflow-x: hidden"
      >
        <ng-container
          *cdkVirtualFor="
            let item of filteredItems | filterWorkspace : searchText : false : (document_type ? selectedTagList : []);
            trackBy: trackByFn;
            let i = index
          "
        >
          <div class="personal-files-table__body width-100per" style="width: auto !important; margin-right: 6px !important">
            <div
              class="body-card flex flex-wrap"
              (click)="viewModal(item, $event); handleClearSelection()"
              style="position: relative"
              [matTooltip]="
                (item?.share_status === 'future' && !isSharedWithOther) || (item?.share_status === 'future' && !isSharedWithMe)
                  ? 'This item is accessible later'
                  : null
              "
            >
              <!-- Colored bar for duplicates - only show when duplicate filter is active -->
              @if(showOnlyDuplicates && getDuplicateColor(item) && !isSharedWithMe && !isSharedWithOther){
              <div
                class="duplicate-color-bar"
                [style.background-color]="getDuplicateColor(item)"
                style="
                  position: absolute;
                  left: 0;
                  top: 0;
                  bottom: 0;
                  width: 4px;
                  z-index: 1;
                  border-top-left-radius: 4px;
                  border-bottom-left-radius: 4px;
                "
              ></div>
              }
              <!-- Colored bar for future share status -->
              @if((item?.share_status === 'future' && !isSharedWithOther)||(item?.share_status === 'future' && !isSharedWithMe)){
              <div
                class="future-share-color-bar"
                style="
                  position: absolute;
                  left: 0;
                  top: 0;
                  bottom: 0;
                  width: 4px;
                  z-index: 1;
                  background-color: #6766b4;
                  border-top-left-radius: 4px;
                  border-bottom-left-radius: 4px;
                "
              ></div>
              }
              <div class="w-2/5 flex fl-justify-start fl-al-center">
                <div class="flex fl-justify-between fl-al-center w-full" style="width: 100% !important">
                  <div class="flex fl-justify-start fl-al-center" style="width: 100% !important">
                    @if(!isSharedWithMe){
                    <div class="w-10" style="margin-top: -8px" id="checkbox-input-select" (click)="$event.stopPropagation()">
                      <mat-checkbox
                        type="checkbox"
                        class="checkbox-input custom-individual-checkBox"
                        [(ngModel)]="item.selected"
                        (change)="toggleChecklist($event, item, i)"
                      >
                      </mat-checkbox>
                    </div>
                    }

                    <div class="ml-4 w-9">
                      <div *ngIf="!item?.security_key" [matTooltip]="item.type">
                        <div [class]="item?.profile_image_url?.indexOf('testing.kinnect') !== -1 ? 'image-container' : 'image-container testImage'">
                          <img [ngClass]="{ 'p-1': item?.profile_image_url?.indexOf('1.svg') }" [src]="item?.profile_image_url" alt="" />
                        </div>
                        <img
                          matTooltip="This file is protected by a security key."
                          *ngIf="item?.security_key"
                          style="height: 21px; position: relative; top: -47px; left: 27px; user-select: auto"
                          src="assets/images/key-icon-min.png"
                        />
                      </div>

                      <div *ngIf="item?.security_key" style="padding-top: 17px">
                        <div [class]="item?.profile_image_url?.indexOf('testing.kinnect') !== -1 ? 'image-container' : 'image-container testImage'">
                          <img [src]="item?.profile_image_url" alt="" />
                        </div>
                        <img
                          matTooltip="This file is protected by a security key."
                          style="height: 21px; position: relative; top: -47px; left: 27px; user-select: auto"
                          src="assets/images/key-icon-min.png"
                        />
                      </div>
                    </div>

                    <div class="flex-align-center ml-4 flex-1" style="width: calc(100% - 78px) !important">
                      <div class="flex fl-col flex-1">
                        <div class="flex items-center">
                          <div
                            class="text-sm font-semibold text-[#010B18] m-0 flex-1 responsive-truncate"
                            [matTooltip]="item?.share_status === 'future' && !isSharedWithOther ? '' : item?.form_name"
                            [ngClass]="{ 'blur-sm': item?.share_status === 'future' && !isSharedWithOther }"
                            *ngIf="globalSearch"
                          >
                            {{ item?.form_name }}
                          </div>
                          <p
                            class="text-sm font-semibold text-[#010B18] m-0 flex-1 responsive-truncate"
                            [matTooltip]="item?.share_status === 'future' && !isSharedWithOther ? '' : item?.form_name"
                            [ngClass]="{ 'blur-sm': item?.share_status === 'future' && !isSharedWithOther }"
                            *ngIf="!globalSearch"
                          >
                            {{ item?.form_name }}
                          </p>

                          <!-- Duplicate Icon -->
                          <div
                            class="ml-2"
                            *ngIf="isDuplicateFormName(item?.form_name) && !item?.ignore_as_duplicate && !isSharedWithMe && !isSharedWithOther"
                            (click)="ignoreAsDuplicate($event, item)"
                          >
                            <div class="w-7 h-7 rounded-full flex items-center justify-center cursor-pointer" style="background-color: #fff0c3">
                              <img
                                src="assets/images/humbleicons_duplicate_color-icon.svg"
                                alt="Duplicate"
                                class="w-5 h-5"
                                matTooltip="Potential Duplicate"
                              />
                            </div>
                          </div>

                          <!-- Identifier Icon (shows when form_name and type are same, but no duplicate) -->
                          <div class="ml-2" *ngIf="isDefaultTemplateName(item) && !isSharedWithMe && !isSharedWithOther">
                            <div class="w-7 h-7 rounded-full flex items-center justify-center" style="background-color: #fff0c3">
                              <img
                                src="assets/images/identifier-icon.svg"
                                alt="Default Template Name"
                                class="w-4 h-4"
                                matTooltip="Default template name is being used. We suggest adding a different name for better searchability."
                              />
                            </div>
                          </div>
                        </div>
                        <p class="text-[#898F9E] font-medium text-[10px] m-0">{{ document_type ? item?.document_type : item?.type }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="w-3/5 flex fl-justify-end fl-al-center gap-1">
                <!-- Tags Column (only show when document_type is true) -->
                @if(document_type){
                <div class="w-[80px] flex-center">
                  <div class="flex items-center justify-center">
                    <div class="relative bg-[#EBF0FA] rounded-full hover:bg-[#6989b7b2]">
                      <img
                        src="{{ getTagSuggestions(item) > 0 ? '/assets/images/Ai_tags-icon.svg' : '/assets/images/tag_icon.svg' }}"
                        class="w-5 h-5 m-2"
                        alt="Tags"
                      />
                      @if(getTagList(item) > 0){
                      <div
                        class="absolute -top-2 -right-2 bg-[#5475C0] text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-semibold"
                      >
                        {{ getTagList(item) }}
                      </div>
                      } @if(getTagSuggestions(item) > 0){
                      <div class="absolute suggestions-icon mt-[-5px] ml-[-3px]">
                        <span class="suggestions-icon-text">Suggestions</span>
                      </div>
                      }
                    </div>
                  </div>
                </div>
                }
                <!-- Links Column -->
                <div class="w-[80px] flex-center">
                  <div class="flex items-center justify-center">
                    <div class="relative bg-[#EBF0FA] rounded-full hover:bg-[#6989b7b2]">
                      <img
                        src="{{ item?.count_linking_suggestion > 0 ? '/assets/images/Ai_link_icon.svg' : '/assets/images/links-icon.svg' }}"
                        class="w-5 h-5 m-2"
                        alt="Links"
                      />
                      @if(item?.count_linking > 0){
                      <div
                        class="absolute -top-2 -right-2 bg-[#5475C0] text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-semibold"
                      >
                        {{ item?.count_linking }}
                      </div>
                      } @if(item?.count_linking_suggestion > 0){
                      <div class="absolute suggestions-icon mt-[-5px] ml-[-3px]">
                        <span class="suggestions-icon-text">Suggestions</span>
                      </div>
                      }
                    </div>
                  </div>
                </div>

                <div class="w-[200px] flex-center min-w-[150px]">
                  <p
                    style="padding: 0 6px; margin-right: 12px"
                    [matTooltip]="item.vault_name"
                    class="text-sm font-semibold text-[#010B18] text-truncate"
                  >
                    {{ item?.vault_name }}
                  </p>
                </div>
               
                <div class="w-[120px] min-w-[110px]">
                  <p class="text-sm font-semibold text-[#898F9E]">{{ item?.updated_at | date }}</p>
                </div>
                <div class="text-truncate w-[154px] min-w-[120px]">
                  <div class="flex flex-center">
                    @if(isSharedFiles){
                    <file-dashboard-status [dashboard_status]="item.share_status"> </file-dashboard-status>
                    }@else{
                    <!-- <file-dashboard-status [dashboard_status]="item.dashboard_status"> </file-dashboard-status> -->
                    <button
                      (click)="handleStatusMenu($event); handleClearSelection()"
                      [disableRipple]="true"
                      [matMenuTriggerFor]="statusMenu"
                      class="status-menu-button status-menu-button-start"
                      [ngClass]="getStatusButtonClass(item?.template_status)"
                    >
                      @if(templateIdsToBeUpdated.includes(item?.id)){
                      <span class="material-icons text-[#1AA140] w-5 h-5 material-symbols-outlined font-bold rotate-90"> progress_activity </span>
                      <img src="/assets/gif/confetti-3.gif" alt="" class="w-full absolute z-10" />
                      } @else{
                      {{ getTemplateStatusLabel(item?.template_status) }}
                      }
                    </button>

                    <mat-menu
                      #statusMenu="matMenu"
                      yPosition="below"
                      xPosition="after"
                      class="popup-menu-panel popup-menu-panel-status statusMenu app__mat-menu-panel"
                      id="statusMenu"
                      style="padding: 0 20px"
                    >
                      @for (status of templateStatuses; track status;) {
                      <button
                        [ngClass]="getStatusMenuItemClass(status.status)"
                        mat-menu-item
                        class="popup-menu-item text-sm font-bold flex items-center justify-center cursor-pointer"
                        (click)="handleTemplateStatusChange(status.status, item)"
                      >
                        {{ status.type }}
                      </button>
                      }
                    </mat-menu>

                    }
                  </div>
                </div>

                <div class="w-[62px] flex items-center justify-center">
                  <button
                    type="button"
                    (click)="toggleItemStar($event, item)"
                    class="star-icon-container flex items-center justify-center"
                    (mouseenter)="starHoverItemId = getItemStarId(item)"
                    (mouseleave)="starHoverItemId = null"
                    [disabled]="isStarUpdating(getItemStarId(item))"
                    style="padding: 0; background: transparent; border: none"
                    aria-label="Starred"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 28 28"
                      fill="none"
                      [ngClass]="{ 'opacity-50': isStarUpdating(getItemStarId(item)) }"
                    >
                      <path
                        d="M17.4837 9.88673L14.5295 3.48183C14.321 3.02982 13.6785 3.02982 13.4701 3.48183L10.5158 9.88673C10.4308 10.0709 10.2562 10.1978 10.0547 10.2217L3.05039 11.0522C2.55608 11.1108 2.35756 11.7217 2.72302 12.0597L7.90151 16.8486C8.05046 16.9864 8.11714 17.1916 8.07761 17.3906L6.70298 24.3087C6.60597 24.797 7.12569 25.1746 7.56005 24.9314L13.7148 21.4863C13.8919 21.3872 14.1077 21.3872 14.2847 21.4863L20.4395 24.9314C20.8738 25.1746 21.3935 24.797 21.2965 24.3087L19.9219 17.3906C19.8824 17.1916 19.949 16.9864 20.098 16.8486L25.2765 12.0597C25.6419 11.7217 25.4434 11.1108 24.9491 11.0522L17.9448 10.2217C17.7433 10.1978 17.5687 10.0709 17.4837 9.88673Z"
                        [attr.stroke]="item?.is_starred ? '#DEA000' : starHoverItemId === getItemStarId(item) ? '#DEA000' : '#828282'"
                        [attr.fill]="item?.is_starred ? '#DEA000' : starHoverItemId === getItemStarId(item) ? 'rgba(222, 160, 0, 0.10)' : 'none'"
                        stroke-width="1.089"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>

                <div class="w-[52px]">
                  <div class="popup-menu" (click)="$event.stopPropagation(); handleClearSelection()">
                    <button mat-icon-button [matMenuTriggerFor]="menuItem" [disableRipple]="true" style="height: 100%">
                      <div class="see-more-btn"><span class="material-icons horiz">more_vert</span></div>
                    </button>

                    <mat-menu #menuItem="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel">
                      @if(isSharedFiles){
                      <button mat-menu-item class="popup-menu-item" (click)="viewModal(item, $event)">
                        <p class="menuitem-text app__menu-item-text">
                          <span class="material-icons material-icons-round menuitem-icon">visibility</span>View Template
                        </p>
                      </button>
                      @if(isSharedWithOther){
                      <button mat-menu-item class="popup-menu-item" (click)="UnShareSingeFileFunction(item)">
                        <p class="menuitem-text app__menu-item-text" style="color: red !important">
                          <img style="margin-right: 6px" src="assets/images/unshare-all-files.svg" />
                          Unshare
                        </p>
                      </button>
                      } }@else{

                      <button mat-menu-item class="popup-menu-item" (click)="viewModal(item, $event)">
                        <p class="menuitem-text app__menu-item-text">
                          <span class="material-icons material-icons-round menuitem-icon">visibility</span>View
                        </p>
                      </button>

                      @if(item?.fid == 1){
                      <button mat-menu-item class="popup-menu-item" (click)="downloadFile(item)">
                        <p class="menuitem-text app__menu-item-text">
                          <span class="material-icons material-icons-round menuitem-icon">download</span>Download
                        </p>
                      </button>
                      }
                      <button mat-menu-item class="popup-menu-item" (click)="openShareModal(item)">
                        <p class="menuitem-text app__menu-item-text">
                          <span class="material-icons material-icons-round menuitem-icon">share</span>Share
                        </p>
                      </button>

                      <button mat-menu-item class="popup-menu-item" (click)="duplicateTemplate(item)">
                        <p class="menuitem-text app__menu-item-text">
                          <span class="material-icons material-icons-round menuitem-icon">content_copy</span>Duplicate Template
                        </p>
                      </button>

                      <button *ngIf="!globalSearch" mat-menu-item class="popup-menu-item" (click)="moveAssetSingleItem(item, item.id)">
                        <p class="menuitem-text app__menu-item-text">
                          <span class="material-icons material-icons-round menuitem-icon">low_priority</span>Move to
                        </p>
                      </button>

                      <button mat-menu-item class="popup-menu-item" (click)="openActivityLogModel(item)">
                        <p class="menuitem-text app__menu-item-text">
                          <img style="margin: 0 12px 0 0px" src="assets/images/activity-log.svg" /> Activity Log
                        </p>
                      </button>

                      <button mat-menu-item class="popup-menu-item" (click)="deleteFileFunction(item)">
                        <p class="menuitem-text app__menu-item-text" style="color: red !important">
                          <img width="14px" src="assets/images/trash-2.svg" style="margin-right: 12px" />Delete Template
                        </p>
                      </button>
                      }
                    </mat-menu>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </cdk-virtual-scroll-viewport>

      } @else{ @if(fileListItems?.length > 0 && !hideSelectAllCheckbox && !is_table_active){
      <div class="flex fl-al-center mb-4" style="width: 100%; justify-content: space-between">
        <div class="flex" id="checkbox-input-select">
          <mat-checkbox type="checkbox" class="checkbox-input" [(ngModel)]="allChecked" (change)="toggleChecklistAll($event)">
            <p class="m-0 text-[#707070] relative top-[4px]">Select All</p>
          </mat-checkbox>
        </div>
        <div class="flex">
          <div class="flex fl-al-center flex-row my-3">
            <p class="title mb-0 text-sm leading-4 text-[#000]">Filter by</p>

            <app-shared-dropdown
              [title]="'Tags'"
              [itemType]="selectedTagList"
              [list]="tagList"
              [itemsLength]="selectedTagList.length"
              [isCustomKey]="true"
              (handleSelectChangeEmitter)="handleSelectChangeEmitter($event, 'selectedTagList')"
              [lableKey]="'key'"
              [valueKey]="'key'"
              class="ml-4"
            >
            </app-shared-dropdown>
          </div>
          <span class="flex flex-row" style="margin: auto 6px">
            <p class="app__form--attribute--title text-[#25508E] m-0 text-sm mt-[-2px] hover:cursor-pointer" [matMenuTriggerFor]="menuItem">
              {{ initialSort === 'name' ? 'Name' : 'Date' }}
            </p>
            <mat-menu #menuItem="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel w-[139px]">
              <button mat-menu-item class="popup-menu-item" (click)="sortByName()">
                <p class="app__form--attribute--title flex items-center text-sm mb-0 font-semibold">Name</p>
              </button>
              <button mat-menu-item class="popup-menu-item" (click)="sortByCreatedDate()">
                <p class="app__form--attribute--title flex items-center text-sm mb-0 font-semibold">Date</p>
              </button>
            </mat-menu>
            <span class="vertical-line" style="border: 1px solid #b2c3db; height: 18px; margin: 0 2px 0 4px"></span>
            <span
              class="material-icons f18 text-[#25508e] hover:cursor-pointer"
              (click)="initialSort === 'name' ? sortByName() : sortByCreatedDate()"
            >
              {{
                initialSort === 'name'
                  ? sortedArrayByName
                    ? 'arrow_downward'
                    : 'arrow_upward'
                  : sortedArrayByDate
                  ? 'arrow_downward'
                  : 'arrow_upward'
              }}
            </span>
          </span>
        </div>
      </div>
      }
      <template-document-grid
        [fileListItems]="filteredItems | filterWorkspace : searchText : false : (document_type ? selectedTagList : [])"
        [allChecked]="allChecked"
        [hideCheckbox]="hideCheckbox"
        [hideSelectAllCheckbox]="hideSelectAllCheckbox"
        (templateDocumentGridEvent)="templateDocumentGridEvent($event)"
      ></template-document-grid>
      }
    </div>
    @if((fileListItems?.length > 0) && ((filteredItems | filterWorkspace : searchText : false : (document_type ? selectedTagList : []))?.length == 0))
    {
    <div class="app__centered-item flex-col w-full h-full mt-1">
      <img src="assets/images/shared-vault/shared-search-result.svg" alt="shared-search-result" />
      <p class="app__form--attribute--title text-center text-xl font-semibold mt-2">No matching results to show</p>
      <p class="app__form--attribute--title text-center text-base text-[#898F9E] font-normal">Try different search terms</p>
    </div>
    }
    <div *ngIf="fileListItems.length == 0">
      <div class="flex-center zero-state" style="margin-top: 40px">
        <img src="assets/images/no-file-icon.svg" style="height: 90px" />
        <p class="no-file-text">No <span class="text-[#25508E]"> Templates </span> to show</p>
        @if(!isSharedFiles){
        <button
          style="font-weight: 700; width: 200px !important; border-radius: 4px !important"
          class="vault-new-btn-sub-vault bg-k-blue text-white w-fit rounded-lg font-bold capitalize box-border text-[14px] sm:text-[14px] mr-[32px] hover:cursor-pointer ml-3"
          mat-button
          (click)="openTemplateRegister($event)"
        >
          <span class="material-icons relative text-lg">add</span>
          Create New Template
        </button>
        }
      </div>
    </div>
  </div>
</div>

<div class="checklist-floater" #floaterContainer>
  @if((fileListItems | filterWorkspace : searchText)?.length != 0 && !globalSearch){
  <checklist-floater-action
    #floater
    [isSharedFiles]="isSharedFiles"
    [selectedItemsArray]="selectedItemsArray"
    (onMoveClicked)="moveChecklists($event)"
    (onDuplicateTemplate)="duplicateTemplateBulkSelected($event)"
  ></checklist-floater-action>
  }
</div>
